import $ from 'jquery';
import {createBrowserHistory} from 'history';
import Texter from "./texter.es6";
import YMetrika from "./yMetrika.es6";

const log = $.noop;

const PAGE_URL = '/flashcards/explorer';
var PAGE_HL = '';

const HashState = {
    toHash(category) {
        return '#cat' + category;
    },

    fromHash(hash) {
        if (hash) {
            const match = /^#cat(\d+)/.exec(hash);
            if (match) {
                return parseInt(match[1]);
            }
        }
        return null;
    }
}

class FlashcardsExplorer {
    constructor(opts) {
        this.hl = opts.hl;
        this.l18n = Texter.create(opts.l18n);
        this.navigation = opts.navigation;
        this.nodeContent = opts.nodeContent;
        this.currentCategory = 0;

        this.metrika = new YMetrika();

        this.history = createBrowserHistory();
        this.history.listen((location, action) => {
            if (location.pathname.startsWith(PAGE_URL)) {
                const locationCategory = HashState.fromHash(location.hash);
                if (locationCategory != null) {
                    this.fetchCategory(locationCategory);
                } else {
                    this.fetchCategory(0);
                }
            }
        });

        this.navigation.find('.fl-explorer-tree__node-expander').click((e) => {
            $(e.currentTarget)
                .closest('li')
                .toggleClass('fl-explorer-tree__node--open');
        });

        this.navigation.find('.fl-explorer-tree__node-label').click((e) => {
            const li = $(e.currentTarget)
                .closest('li')
                .addClass('fl-explorer-tree__node--open');

            const category = li.data('category');
            this.history.push(PAGE_URL + PAGE_HL + HashState.toHash(category));
        });

        const initialCategory = this.history.location ? HashState.fromHash(this.history.location.hash) : null;
        if (initialCategory != null) {
            this.fetchCategory(initialCategory);
        } else {
            this.nodeContent.css('visibility', 'visible');
        }

        if (opts.hl) {
            PAGE_HL = '/' + opts.hl;
        }
        opts.explorerLang.change(() => {
            const newLang = opts.explorerLang.val();
            if (newLang !== this.hl) {
                document.location = '/flashcards/explorer' + (newLang ? `/${newLang}` : '');
            }
        })
    }

    fetchCategory(category) {
        let title = this.navigation.find(`.fl-explorer-tree__node[data-category=${category}] .fl-explorer-tree__node-label`).first().text();
        if (title === null || title === undefined) {
            title = "";
        }

        document.title = this.l18n.get('fexplorer.page.categoryTitle').replace('{0}', title);

        this.currentCategory = category;
        this.navigation.find('.fl-explorer-tree__node').removeClass('fl-explorer-tree__node--active');
        this.navigation.find(`.fl-explorer-tree__node[data-category=${category}]`).addClass('fl-explorer-tree__node--active');
        this.nodeContent.addClass('fl-explorer-content--loading');

        $.get(`${Flashcards.root}/explorer/node?category=${category}&hl=${this.hl}`).done((r) => {
            if (this.currentCategory !== category) {
                return;
            }

            this.nodeContent
                .empty()
                .append(r);

            const hitPath = this.nodeContent.find('.fl-explorer-content__title-path')
                .map((idx, el) => $(el).text())
                .get()
                .join('/');
            this.metrika.hitUrl(PAGE_URL + PAGE_HL + '/' + hitPath);

            this.nodeContent.find('.fl-explorer-pack-item__card-back').each(function () {
                const div = $(this), p = div.find('> div');
                if (p.height() > div.height()) {
                    div.addClass('fl-explorer-pack-item__card-back--fade');
                }
            });

            this.nodeContent
                .removeClass('fl-explorer-content--loading')
                .css('visibility', 'visible');

            // jump to top
            document.documentElement.scrollTop = 0;
        });
    }
}

global.FlashcardsExplorer = FlashcardsExplorer;
